import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../services/api'

const TOKEN_KEY = 'cantina_token'
const USER_KEY  = 'cantina_user'

export const useAuthStore = defineStore('auth', () => {
  const token   = ref(localStorage.getItem(TOKEN_KEY) || null)
  const usuario = ref(JSON.parse(localStorage.getItem(USER_KEY) || 'null'))

  const isAuthenticated = computed(() => !!token.value)
  const nomeUsuario     = computed(() => usuario.value?.nome || 'Usuário')
  const perfil          = computed(() => usuario.value?.perfil || 'operador')
  const iniciais        = computed(() => {
    const nome = usuario.value?.nome || ''
    return nome.split(' ').slice(0, 2).map(p => p[0]).join('').toUpperCase() || 'U'
  })

  function salvarSessao(novoToken, dados) {
    token.value   = novoToken
    usuario.value = dados
    localStorage.setItem(TOKEN_KEY, novoToken)
    localStorage.setItem(USER_KEY, JSON.stringify(dados))
    api.defaults.headers.common['Authorization'] = `Bearer ${novoToken}`
  }

  function limparSessao() {
    token.value   = null
    usuario.value = null
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
    delete api.defaults.headers.common['Authorization']
  }

  async function login(loginUsuario, senha) {
    const res = await api.post('/api/auth/login', { usuario: loginUsuario, senha })
    salvarSessao(res.data.token, res.data.usuario)
    return res.data
  }

  async function logout() {
    try {
      await api.post('/api/auth/logout')
    } catch (_) {
      // ignora erros no logout — limpamos a sessão de qualquer forma
    }
    limparSessao()
  }

  async function verificarToken() {
    if (!token.value) return false
    try {
      api.defaults.headers.common['Authorization'] = `Bearer ${token.value}`
      const res = await api.get('/api/auth/me')
      usuario.value = res.data.usuario
      localStorage.setItem(USER_KEY, JSON.stringify(res.data.usuario))
      return true
    } catch (_) {
      limparSessao()
      return false
    }
  }

  // Restaurar token ao iniciar — só seta o header se não houver token do portal ativo
  if (token.value && !localStorage.getItem('familia_token')) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token.value}`
  }

  return {
    token,
    usuario,
    isAuthenticated,
    nomeUsuario,
    perfil,
    iniciais,
    login,
    logout,
    verificarToken,
    limparSessao,
  }
})
